import { Grid, useMediaQuery } from "@mui/material";
import { Labeled, ReferenceField, SelectField, TextField } from "react-admin";

import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import { SectionTitle } from "features/SectionTitle";
import { CourseChoices, SemestersChoices } from "utils/choices";

const EducationSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Образование"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Тип на обучение">
            <ReferenceField
              source="userInfo.cycleOfEducation"
              reference={erasmusRequests.getCycleOfEducationSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Факултет">
            <ReferenceField
              source="userInfo.structuralUnitId"
              reference={administrationRequests.getStructuralUnitsSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Специалност">
            <ReferenceField
              source="userInfo.specialityId"
              reference={administrationRequests.getSpecialitiesSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Курс">
            <SelectField
              source="userInfo.course"
              choices={CourseChoices}
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Семестър">
            <SelectField
              source="userInfo.semester"
              choices={SemestersChoices}
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default EducationSection;
